import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppState {
  refreshDocuments: boolean;
  bsExchange: number;
  version: string;
}

const initialState: AppState = {
  refreshDocuments: false,
  bsExchange: 35.0,
  version: "",
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAppRefreshDocuments: (state, action: PayloadAction<boolean>) => {
      state.refreshDocuments = action.payload;
    },
    setAppBsExchange: (state, action: PayloadAction<number>) => {
      state.bsExchange = action.payload;
    },
    setAppVersion: (state, action: PayloadAction<string>) => {
      state.version = action.payload;
    },
  },
});

export const { setAppRefreshDocuments, setAppBsExchange, setAppVersion } =
  appSlice.actions;

export default appSlice.reducer;
